/** @jsx jsx */
import { jsx, Box, Container } from 'theme-ui';
import SectionHeading from 'components/section-heading';
import Feature from 'components/cards/feature';

import icon1 from 'assets/images/icons/interactive-dashboard.svg';
import icon2 from 'assets/images/icons/no-code.svg';
import icon3 from 'assets/images/icons/machine-learning.svg';
import icon4 from 'assets/images/icons/data-management.svg';
import icon5 from 'assets/images/icons/scalability.svg';
import icon6 from 'assets/images/icons/oem.svg';

const data = [
  {
    id: 1,
    icon: icon1,
    path: '#!',
    title: 'Interactive Dashboards',
    description: `Explore your data with interactive visualizations. Drill down and filter your data.`,
  },
  {
    id: 2,
    icon: icon2,
    path: '#!',
    title: 'No code',
    description: `Visually design your dashboards in minutes, no code needed.`,
  },
  {
    id: 3,
    icon: icon3,
    path: '#!',
    title: 'Automatic ML',
    description: `Let your clients benefit from machine learning without the need for a data scientist `,
  },
  {
    id: 4,
    icon: icon4,
    path: '#!',
    title: 'Data management',
    description: `You can merge your data from differents sources in minutes. No ETL needed.`,
  },
  {
    id: 5,
    icon: icon5,
    path: '#!',
    title: 'Extensibility and scalability',
    description: `We are a cloud native application that naturally scales.`,
  },
  {
    id: 6,
    icon: icon6,
    path: '#!',
    title: 'Integration & OEM',
    description: `Embed your dashboards in minutes. Administrate your users by API. White label available.`,
  },
];

const UltimateFeatures = () => {
  return (
    <Box as="section" id="features" variant="section.ultimateFeatures">
      <Container>
        <SectionHeading
          sx={styles.heading}
          title="Ultimate features you must appreciate"
          description=""
        />
        <Box sx={styles.features}>
          {data?.map(item => (
            <Feature className="feature-item" key={item.id} data={item} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default UltimateFeatures;

const styles = {
  heading: {
    marginBottom: [50, 50, 80],
    p: {
      maxWidth: 490,
      margin: ['10px auto 0'],
    },
  },
  features: {
    gap: [60, 60, 60, 40, '50px 30px', 60],
    display: ['grid', 'grid'],
    maxWidth: 1030,
    margin: '0 auto',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      'repeat(3, 1fr)',
    ],
    '.feature-item': {
      display: ['block'],
      textAlign: 'center',
      maxWidth: [290, 260, 260, 280, 'none'],
      m: ['0 auto', '0 auto', '0 auto', '0 auto', '0 auto', 0],
      figure: {
        m: ['0 0 20px'],
      },
      h4: {
        mb: ['15px', '15px', '20px'],
      },
      p: {
        fontSize: ['14px', '14px', '16px', '16px', '14px', '16px'],
      },
    },
  },
};
